<template>
  <div>
    <button @click="toggle" class="p-1">
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="fill-black selection:fill-theme-primary hover:fill-theme-secondary transition-colors duration-200"
          d="M11 5.5C11 8.53824 8.53735 11 5.5 11C2.46265 11 0 8.53824 0 5.5C0 2.46353 2.46265 0 5.5 0C8.53735 0 11 2.46353 11 5.5ZM5.64759 1.81855C4.43899 1.81855 3.66815 2.32768 3.06283 3.23254C2.98442 3.34977 3.01065 3.50787 3.12305 3.5931L3.89258 4.17658C4.00801 4.26412 4.17248 4.24329 4.26217 4.12952C4.65834 3.62703 4.93 3.33564 5.533 3.33564C5.98606 3.33564 6.54646 3.62723 6.54646 4.06656C6.54646 4.39869 6.27228 4.56926 5.82494 4.82006C5.30324 5.11252 4.6129 5.47651 4.6129 6.3871V6.47581C4.6129 6.62278 4.73206 6.74194 4.87903 6.74194H6.12097C6.26794 6.74194 6.3871 6.62278 6.3871 6.47581V6.44624C6.3871 5.81503 8.23195 5.78875 8.23195 4.08065C8.23195 2.79431 6.89764 1.81855 5.64759 1.81855ZM5.5 7.31855C4.93747 7.31855 4.47984 7.77618 4.47984 8.33871C4.47984 8.90122 4.93747 9.35887 5.5 9.35887C6.06253 9.35887 6.52016 8.90122 6.52016 8.33871C6.52016 7.77618 6.06253 7.31855 5.5 7.31855Z"
        />
      </svg>
    </button>
    <div id="dialog" :class="open ? 'open' : ''"><div class="bg-white rounded-lg p-[20px] w-[200px] shadow-xl">
      <button @click="toggle" class="btn btn-sm btn-circle btn-ghost absolute right-[2px] top-[2px] text-black">
        ✕
      </button>
      <slot></slot>
    </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const open = ref(false);
const toggle = () => {
  open.value = !open.value;
};
</script>
<style scoped lang="scss">
button:hover path {
  @apply fill-theme-secondary;
}

#dialog {
  position: absolute;
  height:0;
  transition: opacity 200ms;
  transition: visibility 200ms;
  z-index: 50;
  opacity: 0;
  visibility: hidden;
}

#dialog.open {
  visibility: visible;
  opacity: 1;
}
</style>
